import { collectChildren } from "../utils";
export function mapAdditiveExpression(node, ctx) {
    const children = collectChildren(node);
    if (children.length === 1) {
        return ctx.mapScalarExpression(children[0]);
    }
    let left = ctx.mapScalarExpression(children[0]);
    let i = 1;
    while (i < children.length) {
        const opNode = children[i];
        const rightNode = children[i + 1];
        if (!rightNode)
            break;
        const op = ctx.slice(opNode);
        const right = ctx.mapScalarExpression(rightNode);
        left = {
            type: "BinaryExpression",
            operator: op,
            left,
            right,
            start: node.from,
            end: node.to,
        };
        i += 2;
    }
    return left;
}
export function mapMultiplicativeExpression(node, ctx) {
    const children = collectChildren(node);
    if (children.length === 1) {
        return ctx.mapScalarExpression(children[0]);
    }
    let left = ctx.mapScalarExpression(children[0]);
    let i = 1;
    while (i < children.length) {
        const opNode = children[i];
        const rightNode = children[i + 1];
        if (!rightNode)
            break;
        const op = ctx.slice(opNode);
        const right = ctx.mapScalarExpression(rightNode);
        left = {
            type: "BinaryExpression",
            operator: op,
            left,
            right,
            start: node.from,
            end: node.to,
        };
        i += 2;
    }
    return left;
}
